import { h as o } from "vue";
const c = (n, r) => {
  const a = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill-rule="evenodd" d="M26.88 24.162A7.146 7.146 0 0124 18.4v-4.8c0-4.02-2.71-7.42-6.4-8.467V4c0-1.323-1.077-2.4-2.4-2.4A2.403 2.403 0 0012.8 4v1.133C9.11 6.18 6.4 9.579 6.4 13.6v4.8a7.149 7.149 0 01-2.88 5.762.8.8 0 00.48 1.44h7.28a4.006 4.006 0 003.918 4.8 4.006 4.006 0 003.92-4.8h7.28a.8.8 0 00.48-1.44h.002zM14.4 4A.8.8 0 0116 4v.837a8.813 8.813 0 00-1.6 0V4zm3.2 22.4c0 1.323-1.077 2.4-2.4 2.4a2.403 2.403 0 01-2.262-3.2h4.524c.09.256.138.526.138.8zM5.987 24a8.905 8.905 0 001.055-1.602A8.697 8.697 0 008 18.4v-4.8c0-3.97 3.23-7.2 7.2-7.2s7.2 3.23 7.2 7.2v4.8c0 1.408.323 2.754.958 3.998A8.85 8.85 0 0024.413 24H5.986h.001z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (n.title) {
    const e = document.createElementNS(a, "title");
    e.textContent = n.title, t.appendChild(e);
  }
  const i = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, s) => ({
    ...e,
    [s.name]: s.value
  }));
  return o(
    "svg",
    {
      ...i,
      ...r.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  c as default
};
//# sourceMappingURL=BellIcon.D6Uir9XB.js.map
